import Head from "next/head";

import ConnectToolsMain from "@/components/info/connect-tools-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function ConnectTools() {
  return (
    <>
      <Head>
        <title>{seoData.INFO_CONNECT_TOOLS.title}</title>
        <SeoMetaData data={seoData.INFO_CONNECT_TOOLS} />
      </Head>

      <ConnectToolsMain />
    </>
  );
}
